module.exports = __webpack_public_path__ + "img/circle-cross-subscribtion-plan-new.041efbf4.svg";